module.exports = __webpack_public_path__ + "static/media/你是我最深爱的人（永邦）.b9b0ddff.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/music/你是我最深爱的人（永邦）.mp3
// module id = 489
// module chunks = 0